import styled from "styled-components";
import classnames from 'classnames';
import { useState } from "react";
import MoonLoader from 'react-spinners/MoonLoader';
import ReactTooltip from "react-tooltip";

interface Props {
    className?: string;
    size: number;
    dataTip?: string;
    disabledDataTip?: string;
    disabled?: boolean;
    loading?: boolean;
    simulateLoading?: boolean;
    onClick?: () => any;
    /** Optional hover color */
    hoverColor?: string;
    /** Optional hover scale (default 1.2) */
    hoverScale?: number;
}

export default function Icon({
    className,
    size,
    onClick,
    dataTip,
    disabledDataTip,
    disabled,
    simulateLoading,
    loading,
    hoverColor,
    hoverScale = 1.2,
}: Props) {

    const useSize = `${size}px`;

    const [internalLoading, setInternalLoading] = useState(false);

    const handleClick = () => {
        if (onClick) onClick();
        if (simulateLoading) {
            setInternalLoading(true);
            setTimeout(() => {
                setInternalLoading(false);
            }, 2000);
        }
    }

    if (loading || internalLoading) {
        return (
            <MoonLoader
                size={28}
                color={'#51c878'}
            />
        );
    }

    return (
        <>
            <ReactTooltip />
            <CustomIcon
                className={classnames(className, disabled && 'custom-disabled')}
                useSize={useSize}
                onClick={handleClick}
                data-tip={disabled ? (disabledDataTip || '') : dataTip}
                hoverColor={hoverColor}
                hoverScale={hoverScale}
            />
        </>
    );
}

const CustomIcon = styled.i<{
    useSize: string;
    hoverColor?: string;
    hoverScale: number;
}>`
    font-size: ${p => p.useSize};
    transition: color 0.2s ease, transform 0.2s ease;
    &:hover {
        cursor: pointer;
        color: ${p => p.hoverColor || 'inherit'};
        transform: scale(${p => p.hoverScale});
    }
`;
